<template>
    <div @click="musicPlay">
        <img ref="audio" class="music light" :src="tgImg" />
        <audio  :src="this.$store.state.musicPath" ref="zz" id="myaudio" controls hidden :loop="loop">
            <source :src="this.$store.state.musicPath" type="audio/mpeg" >
        </audio>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'music',
  props: ['need'],
  data () {
    return {
      toggle: true,
      loop: false,
      onPath: require('../assets/music.png'),
      offPath: require('../assets/music_mute.png'),
      musicPath: ''
    }
  },
  computed: {
    tgImg () {
      let result = this.toggle // 这仅仅是为了触发
      this.toggle ? result = this.offPath : result = this.onPath
      if (this.need) {
        this.$store.commit('musicSet', !this.toggle)
      }
      return result
    }
  },
  methods: {
    musicPlay (e) {
      e ? e.preventDefault() : ''
      this.dontBorderMeFUCKYOU()
      try {
        if (document.getElementById('myaudio').paused) {}
      } catch (e) {
        if (this.toggle === true) {
          document.getElementById('myaudio').play()
          document.querySelector('.light').classList.add('light-go')
          this.toggle = false
        } else {
          document.getElementById('myaudio').pause()
          document.querySelector('.light').classList.remove('light-go')
          this.toggle = true
        }
      }
      const musicdom = document.getElementById('myaudio')

      if (musicdom.paused) {
        musicdom.play()
        document.querySelector('#myaudio').play()
        // document.querySelector('.music').classList.add('rotate')
        // musicdom.play()
        if (!musicdom.paused) {
          document.querySelector('.light').classList.add('light-go')
          this.toggle = false
        }
      } else {
        musicdom.pause()
        // document.querySelector('.music').classList.remove('rotate')
        if (musicdom.paused) {
          document.querySelector('.light').classList.remove('light-go')
          this.toggle = true
        }
      }
    },
    rawPlay (init = false) {
      const music_dom = document.querySelector('#myaudio')
      if (music_dom.paused) {
        music_dom.play()
        let a = ''
        if (init) {
          let a = setInterval(() => {
            music_dom.play()
          }, 40)
        }
        if (!music_dom.paused) {
          if (init) {
            setTimeout(() => {
              clearInterval(a)
            }, 400)
          }
          document.querySelector('.light').classList.add('light-go')
          this.toggle = false
        }
      }
    },
    rawPause () {
      const music_dom = document.querySelector('#myaudio')
      if (!music_dom.paused) {
        const music_dom = document.querySelector('#myaudio')
        music_dom.pause()
        if (music_dom.paused) {
          this.toggle = true
        }
      }
    },
    initMusic () {
      if (!this.$store.getters.isWeiXin) {
        this.musicCanPlaythrough()
        this.rawPlay()
      } else { // 微信
        document.addEventListener('WeixinJSBridgeReady', () => {
          console.log('??dasdasdasdas')
          this.musicCanPlaythrough()
          this.rawPlay()
        }, false)
      }
    },
    musicCanPlaythrough () {
      // setTimeout(this.rawPlay,1000)
      const a = function promiseForBoolean (obj = {}) {
        let interval; let promise; let save = {}
        Object.assign(save, obj)
        const func = (resolve) => {
          if (obj.boolean === !save.boolean) {
            clearInterval(interval)
            resolve()
          }
        }
        promise = new Promise((resolve, reject) => {
          interval = setInterval(func.bind(null, resolve), 1000)
        })
        return promise
      }

      a(get).then(this.rawPlay)
      // wjhTool.musicCount(100)
      // this.rawPlay()
      // 使用方法 外部音乐准备好了 get get.boolean = false  然后改成true 那我为什么不直接rawpaly? 哦 因为是initWeiXin启动的方法，但是我又不是真正准备好了 懂了。
    },
    dontBorderMeFUCKYOU () {
      localStorage.setItem('fuckyou', '1')
    }
  },
  mounted () {
      document.querySelector('#myaudio').addEventListener('ended', () => {
        this.toggle = true
        if (this.need) {
          this.$parent.listenDone = true
        }
      })
      const ua = navigator.userAgent.toLowerCase()
      const handel = () => {
        this.rawPlay()
        if (!document.querySelector('#myaudio').paused) {
          // document.removeEventListener('click', handel, false)
          document.removeEventListener('touchstart', handel, false)
        }
      }
      // document.addEventListener('click', handel, true)
      document.addEventListener('touchstart', handel, false)
      this.initMusic()
  }
}
</script>

<style lang="scss" scoped>
    .music{
        width: px2html(20px);
        height: px2html(20px);
        pointer-events: unset;
    }
</style>

<style>
    .l6ight {
        animation: rotate 7s infinite linear;
    }
    @keyframes rotate{
        0%{
            transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
        }
    }

</style>
